
import { gql } from '@apollo/client'
import { getGraphqlClient, Core, Config } from '@danone-global/internal/react/core'


export const GET_CHANNELS_ID_PRICES_QUERY = gql`
  query getChannelsPrice($sku: String!, $locale: Locale!) {
    product(sku: $sku) {
      __typename
      masterData {
        current {
          masterVariant {
            sku
            attributesRaw {
              name
              value
            }
          }
          variant(sku: $sku) {
            prices {
              custom {
                customFieldsRaw {
                  name
                  value
                }
              }
              channel {
                id
                name(locale: $locale)
              }
            }
          }
        }
      }
    }
  }
`

export const getPriceList = async (
  core: Core,
  acceptCache = true,
  sku: string,
) => {
  const apolloClient = getGraphqlClient(core.config)
  let queryData = {sku, locale: core.localeConfig.locale}
  const { data } = await apolloClient.query({
    query: GET_CHANNELS_ID_PRICES_QUERY,
    variables: queryData,
    // If cache is accepted then use the default
    fetchPolicy: acceptCache ? undefined : 'network-only',
  })
  return data?.product?.masterData?.current
}

